import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { ToastProvider } from '@uhg-abyss/web/ui/Toast';
import { theme } from './theme/abyss';
import { store } from './store';
import App from './App';
import './styles/index.css';

const LOCAL_DEV_CONFIG = {
  userId: import.meta.env.VITE_USER_ID || 'vmalhot5',
  sessionId: import.meta.env.VITE_SESSION_ID || `session_${Date.now()}`,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://rate-load-automation.optum-opera-dev.net',
  coreApiBaseUrl: import.meta.env.VITE_CORE_API_BASE_URL || '',
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ToastProvider />
        <App
          userId={LOCAL_DEV_CONFIG.userId}
          sessionId={LOCAL_DEV_CONFIG.sessionId}
          apiBaseUrl={LOCAL_DEV_CONFIG.apiBaseUrl}
          coreApiBaseUrl={LOCAL_DEV_CONFIG.coreApiBaseUrl}
        />
      </ThemeProvider>
    </Provider>
  </StrictMode>
);
